interface PartnerItem {
  title: string
  logo: string
  link?: string
  logoMb?: string
}

export function usePartnerProvider() {
  const logoPartners: PartnerItem[] = [
    {
      title: 'KSport',
      logo: '/images/providers/logo-ksport.svg',
      logoMb: '/images/providers/logo-ksport.png',
    },
    {
      title: 'MSport',
      logo: '/images/providers/logo-msport.svg',
      logoMb: '/images/providers/logo-msport.png',
    },
    {
      title: 'BTI',
      logo: '/images/providers/logo-bti.svg',
      logoMb: '/images/providers/logo-bti.png',
    },
    {
      title: 'Saba',
      logo: '/images/providers/logo-saba.svg',
      logoMb: '/images/providers/logo-saba.png',
    },
    {
      title: 'ASport',
      logo: '/images/providers/logo-asport.svg',
      logoMb: '/images/providers/logo-asport.png',
    },
    {
      title: 'HitClub',
      link: 'https://hit.club',
      logo: '/images/providers/logo-hit-club.webp',
      logoMb: '/images/providers/logo-hit-club.webp',
    },
    {
      title: 'Pgsoft',
      logo: '/images/providers/logo-pgsoft.png',
      logoMb: '/images/providers/logo-pgsoft.png',
    },
    {
      title: 'Spribe',
      logo: '/images/providers/logo-spribe.svg',
      logoMb: '/images/providers/logo-spribe.png',
    },
    {
      title: 'Evolution',
      logo: '/images/providers/logo-evolution.webp',
      logoMb: '/images/providers/logo-evolution.webp',
    },
    {
      title: 'Techplay',
      logo: '/images/providers/logo-techplay.svg',
      logoMb: '/images/providers/logo-techplay.webp',
    },
    {
      title: 'Ebet',
      logo: '/images/providers/logo-ebet.webp',
      logoMb: '/images/providers/logo-ebet.webp',
    },
    {
      title: 'Dream Gaming',
      logo: '/images/providers/logo-dream-gaming.svg',
      logoMb: '/images/providers/logo-dream-gaming.webp',
    },
    {
      title: 'Sexy',
      logo: '/images/providers/logo-sexy.webp',
      logoMb: '/images/providers/logo-sexy.webp',
    },
    {
      title: 'Via',
      logo: '/images/providers/logo-via.webp',
      logoMb: '/images/providers/logo-via.webp',
    },
    {
      title: 'Vivo',
      logo: '/images/providers/logo-vivo.webp',
      logoMb: '/images/providers/logo-vivo.webp',
    },
    {
      title: 'Yeebet',
      logo: '/images/providers/logo-yeebet.webp',
      logoMb: '/images/providers/logo-yeebet.webp',
    },
    {
      title: 'Askmebet',
      logo: '/images/providers/logo-askmebet.webp',
      logoMb: '/images/providers/logo-askmebet.webp',
    },
    {
      title: 'Simpleplay',
      logo: '/images/providers/logo-simpleplay.webp',
      logoMb: '/images/providers/logo-simpleplay.webp',
    },
    {
      title: 'Playngo',
      logo: '/images/providers/logo-playngo.webp',
      logoMb: '/images/providers/logo-playngo.webp',
    },
    {
      title: 'CQ9',
      logo: '/images/providers/logo-cq9.webp',
      logoMb: '/images/providers/logo-cq9.webp',
    },
    {
      title: 'Microgaming',
      logo: '/images/providers/logo-microgaming.webp',
      logoMb: '/images/providers/logo-microgaming.webp',
    },
    {
      title: 'Onegame',
      logo: '/images/providers/logo-onegame.webp',
      logoMb: '/images/providers/logo-onegame.webp',
    },
    {
      title: 'Ezugi',
      logo: '/images/providers/logo-ezugi.webp',
      logoMb: '/images/providers/logo-ezugi.webp',
    },
    {
      title: 'Fachai',
      logo: '/images/providers/logo-fachai.webp',
      logoMb: '/images/providers/logo-fachai.webp',
    },
    {
      title: 'Pragmatic Play',
      logo: '/images/providers/logo-pragmatic-play.webp',
      logoMb: '/images/providers/logo-pragmatic-play.webp',
    },
    {
      title: 'Ga28',
      logo: '/images/providers/logo-ga28.webp',
      logoMb: '/images/providers/logo-ga28.webp',
    },
    {
      title: 'Hacksaw',
      logo: '/images/providers/logo-hacksaw.webp',
      logoMb: '/images/providers/logo-hacksaw.webp',
    },
    {
      title: 'Qtech',
      logo: '/images/providers/logo-qtech.webp',
      logoMb: '/images/providers/logo-qtech.webp',
    },
    {
      title: 'Jdb',
      logo: '/images/providers/logo-jdb.webp',
      logoMb: '/images/providers/logo-jdb.webp',
    },
    {
      title: 'Evoplay',
      logo: '/images/providers/logo-evoplay.webp',
      logoMb: '/images/providers/logo-evoplay.webp',
    },
    {
      title: 'Jili',
      logo: '/images/providers/logo-jili.webp',
      logoMb: '/images/providers/logo-jili.webp',
    },
    {
      title: 'WS168',
      logo: '/images/providers/logo-ws168.webp',
      logoMb: '/images/providers/logo-ws168.webp',
    },
    {
      title: 'Saba Store',
      logo: '/images/providers/logo-saba-store.webp',
      logoMb: '/images/providers/logo-saba-store.webp',
    },
    {
      title: 'Hogaming',
      logo: '/images/providers/logo-hogaming.webp',
      logoMb: '/images/providers/logo-hogaming.webp',
    },
    {
      title: 'Spinomenal',
      logo: '/images/providers/logo-spinomenal.webp',
      logoMb: '/images/providers/logo-spinomenal.webp',
    },
    {
      title: 'Rikvip',
      logo: '/images/providers/logo-rikvip.webp',
      logoMb: '/images/providers/logo-rikvip.webp',
    },
    {
      title: 'Habanero',
      logo: '/images/providers/logo-habanero.webp',
      logoMb: '/images/providers/logo-habanero.webp',
    },
    {
      title: 'Isc',
      logo: '/images/providers/logo-isc.webp',
      logoMb: '/images/providers/logo-isc.webp',
    },
    {
      title: 'Netent',
      logo: '/images/providers/logo-netent.webp',
      logoMb: '/images/providers/logo-netent.webp',
    },
    {
      title: 'Red Tiger',
      logo: '/images/providers/logo-red-tiger.webp',
      logoMb: '/images/providers/logo-red-tiger.webp',
    },
    {
      title: 'Iwin',
      logo: '/images/providers/logo-iwin.webp',
      logoMb: '/images/providers/logo-iwin.webp',
    },
    {
      title: 'B52',
      logo: '/images/providers/logo-b52.webp',
      logoMb: '/images/providers/logo-b52.webp',
    },
    {
      title: 'Horn Gaming',
      logo: '/images/providers/logo-horn-gaming.webp',
      logoMb: '/images/providers/logo-horn-gaming.webp',
    },
    {
      title: 'SA Gaming',
      logo: '/images/providers/logo-sa-gaming.webp',
      logoMb: '/images/providers/logo-sa-gaming.webp',
    },
  ]
  return {
    logoPartners,
  }
}
